import { Injectable } from '@angular/core';
import {TractorService} from './tractor.service';
import {HttpClient} from '@angular/common/http';
import {ConfigService, ErrorsService, Tractor} from 'shared';

@Injectable({
  providedIn: 'root'
})
export class TractorByImeiService extends TractorService {

  constructor(http: HttpClient, config: ConfigService, errors: ErrorsService) {
    super(http, config, errors);
  }


  protected key(): string {
    return 'tracker.imei';
  }
}


